import "./Comment.css"
import DateFormatter from "../DateFormatter";

function Comment({ comment }) {
  let dateString = '';
  if (comment.date) {
    dateString = DateFormatter.formatDate(comment.date);
  }
  return (
    <div className='comment'  key={ comment.id }>
      <div className='title'>
        { comment.id }: <em>{ comment.name }</em> - { dateString }
      </div>
      <div className='content'>
        { comment.content.split(/(?:\r\n){2,}/).map( (paragraph, i) =>
          <p key={i} className={i === 0 ? 'first' : ''}>{
            paragraph.replaceAll(/â€[“™¦]/g, (chr) => chr === "â€¦" ? "..." : "'")
          }</p>
        ) }
      </div>
      {/* Admin options */}
    </div>
  );
}

export default Comment;